import { memo } from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import SectionBackground from "../layout/SectionBackground";
import SectionTitle from "../layout/SectionTitle";
import { theme } from "@/theme";
import { useIsMobile } from "@/hooks/use-mobile";

const CallToAction = () => {
  const isMobile = useIsMobile();

  return (
    <section className="relative py-24 px-4">
      <SectionBackground />
      <div className="relative max-w-5xl mx-auto text-center">
        <div className="mb-12">
          <SectionTitle
            title="Take the Next Step in Your Dance Journey"
            accent="Dance Journey"
            subtitle="Join our community and discover the art of connection through movement"
            align="center"
            size="xl"
          />
        </div>

        {/* Join Now CTA */}
        <Link to="/pricing">
          <motion.button
            whileHover={!isMobile ? { 
              scale: 1.1,
              y: -5,
            } : { scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ 
              duration: 0.5, 
              delay: 0.4,
              type: isMobile ? "tween" : "spring",
              stiffness: 400,
              damping: 10
            }}
            className="theme-button-primary rounded-full relative overflow-hidden"
            style={{
              padding: '14px 36px',
              fontSize: '16px',
              fontWeight: 600,
              boxShadow: `0 0 20px ${theme.colors.accent}50`
            }}
          >
            <motion.span 
              className="relative z-10"
              animate={!isMobile ? {
                x: [0, 3, 0],
              } : {}}
              transition={{
                duration: 1.5,
                repeat: Infinity,
                ease: "easeInOut"
              }}
            >
              Join Now →
            </motion.span>
            
            {/* Ripple effect - desktop only */}
            {!isMobile && (
              <motion.div
                className="absolute inset-0 rounded-full"
                initial={{ scale: 0, opacity: 0.5 }}
                whileHover={{
                  scale: 1.5,
                  opacity: 0,
                }}
                transition={{ duration: 0.6 }}
                style={{
                  background: `radial-gradient(circle, ${theme.colors.accent}66, transparent)`
                }}
              />
            )}
          </motion.button>
        </Link>
      </div>
    </section>
  );
};

export default memo(CallToAction);
